import { useMemo, useState } from 'react';
import { getIdentityVerification, IdentityVerificationStatus } from '../../../../../api/Providers/VerificationDetails';
import { useOnce } from '../../../../../hooks';

const useVerificationDetails = (providerId: number) => {
  const [
    identityVerification,
    setIdentityVerification,
  ] = useState<IdentityVerificationStatus | undefined>();
  const needsMailingAddress = useMemo(() => (
    !!identityVerification?.needs_mailing_address_charges
  ), [identityVerification?.needs_mailing_address_charges]);

  useOnce(async () => {
    const idVerification = await getIdentityVerification(providerId);
    setIdentityVerification(idVerification);
  }, providerId || null);

  return {
    identityVerification,
    needsMailingAddress,
  };
};

export default useVerificationDetails;
